module.exports = __webpack_public_path__ + "static/media/zec.4775683f.svg";